<template>
  <div class="brief">
    <div class="understand-container">
      <div class="understand-header"></div>
      <div class="understand">
        <h3>前沿思考</h3>
        <h1>
          <p>「首次公开」科技领袖</p>
          <p>的深度思考</p>
        </h1>
        <p>
          在前沿思考论坛，我们希望对那些看似简单的概念做一些更深入的思考。这也许不会带给你太多绝对确定的答案，但我们的目的恰恰是引发出更值得思考的问题。因为我们相信，思考是通向必然的唯一路径。
        </p>
      </div>
    </div>
    <div class="speech-container">
      <div class="speech-header"></div>
      <div class="speech">
        <h3>主题演讲</h3>
        <h1>
          <p>洞悉未来，找到科技</p>
          <p>创新的方向</p>
        </h1>
        <p>
          别人理解的未来世界是什么样的？下一个十年什么是必然的潮流与趋势？在极客公园创新大会，生生不息的创新者们将他们的独立思考折叠进每一个演讲、访谈和演示。这里有久经沙场的江湖「老炮」，也有初露锋芒的「新秀」，你需要了解的未来新世界，他们会是你的领路人。
        </p>
      </div>
    </div>
    <div class="interview-container">
      <div class="interview-header"></div>
      <div class="interview">
        <h3>「鹏友说」深度访谈</h3>
        <h1><p>现场「探秘」商业领袖</p></h1>
        <p>
          人类社会每一个重要的变革都是由「人」所推动，又是什么推动着他们的前进？他们也许是企业的领袖、也许是行业的权威，在「鹏友说」，他们只是那个真实的创新者。中国最资深的科技媒体人张鹏替你「探秘」商业领袖，跳脱出采访「套路」，用犀利地发问挖掘出「真心话」。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Brief'
}
</script>

<style scoped lang="less">
  .brief {
    display: flex;
    justify-content: space-between;
    width: 228vh;
    margin-left: 7vh;

    > div {
      width: 72vh;

      > div:first-of-type {
        height: 63.5vh;
      }
    }
  }

  .understand-header {
    background: url("https://summit-img.geekpark.net/ifx/images/1_%E6%9D%8E%E7%BF%94%E5%BC%A0%E9%B9%8F%E5%AF%B9%E8%B0%88.v2.jpg") 0 0 ~ "/" cover;
  }

  .speech-header {
    background: url("https://summit-img.geekpark.net/ifx/images/2.%E5%A4%A7%E9%87%8F%E5%98%89%E5%AE%BE%E8%B6%85%E9%95%BF%E6%BC%94%E8%AE%B2%E6%97%B6%E9%95%BF.jpg") 0 0 ~ "/" cover;
  }

  .interview-header{
    background: url("https://summit-img.geekpark.net/ifx/images/3.%E9%B9%8F%E5%8F%8B%E8%AF%B4%E7%8E%B0%E5%9C%BA.jpg") 0 0 ~ "/" cover;
  }

  .understand, .speech, .interview {
    margin-top: 2vh;
    text-align: left;

    h3 {
      color: #ff3c00;
      font-size: 2vh;
    }

    h1 {
      margin-top: 0.8vh;
      height: 12vh;
      font-size: 3.5vh;
    }

    > p {
      width: 90%;
      line-height: 1.5;
      text-align: justify;
      font-size: 1.8vh;
      font-weight: 100;
    }
  }

  .understand h1 p:first-of-type {
    text-indent: -0.7em;
  }

  .speech-header, .interview-header {
    div {
      width: 100%;
      height: 33.33%;
    }
  }
</style>
